module.exports = __webpack_public_path__ + "img/GRS.d837d639.svg";